import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Elastic, Expo, TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";

import {ch2_p04} from "../../../layouts/ch2_p04/ch2_p04"

export class Chapter2Page4 extends AbstractStoryState {

	readonly bg = this.addChild(new SceneSprite());
	readonly phone = this.addChild(new SceneSprite());
	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch2_p04/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch2_p04/"));
    readonly lines = this.addChild(SceneSprite.withPrefix("ch2_p04/"));

    readonly phoneHitArea = new Array<number>();

    public init(pSize: PIXI.Point, pData: any) {
		// exported layout from Animate CC
        ch2_p04.call(this);
		this.frameLeft.visible = false;
		this.frameRight.visible = false;

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
		super.animateIn(pOnComplete);
	}

	public onAnimateInComplete() {
		super.onAnimateInComplete();
		// interaction
		this.phone.interactive = true;
		this.phone.buttonMode = true;
		this.phone.accessible = true;
		this.showHint(this.phone, "hand", 8);
		this.phone.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
			this.gotoNextState({transition: "up"});
		});
	}
}